// (c) chaehongee. Confidential and proprietary.

import { useEffect } from 'react'

interface UseUndoRedoShortcutsOptions {
    enabled: boolean
    onUndo: () => void
    onRedo: () => void
}

/**
 * Registers Cmd/Ctrl+Z for undo and Cmd/Ctrl+Shift+Z or Cmd/Ctrl+Y for redo.
 * Ignores key events originating from input-like elements.
 */
export function useUndoRedoShortcuts(options: UseUndoRedoShortcutsOptions): void {
    const { enabled, onUndo, onRedo } = options

    useEffect(() => {
        if (!enabled) return
        const onKeyDown = (e: KeyboardEvent) => {
            const target = e.target as HTMLElement | null
            if (target) {
                const tag = target.tagName
                const isInputLike =
                    tag === 'INPUT' ||
                    tag === 'TEXTAREA' ||
                    target.isContentEditable
                if (isInputLike) return
            }
            const isCmdOrCtrl = e.metaKey || e.ctrlKey
            if (!isCmdOrCtrl) return
            const key = e.key.toLowerCase()
            if (key === 'z') {
                if (e.shiftKey) {
                    e.preventDefault()
                    onRedo()
                } else {
                    e.preventDefault()
                    onUndo()
                }
            } else if (key === 'y') {
                e.preventDefault()
                onRedo()
            }
        }
        window.addEventListener('keydown', onKeyDown)
        return () => window.removeEventListener('keydown', onKeyDown)
    }, [enabled, onUndo, onRedo])
}

export default useUndoRedoShortcuts


